import { signal } from '@preact/signals-core'
import { COLOR_SCHEME_LIGHT } from '../const'
import { searchbuttonConfig as defaultConfig } from '../defaultConfig'
import type { ColorScheme } from '../types'

export const colorScheme = signal<ColorScheme>(COLOR_SCHEME_LIGHT)
export const themeConfig = signal<typeof defaultConfig.ui.theme>(defaultConfig.ui.theme)
export const buttonLabel = signal<string>('Search')
export const className = signal<string>('')
export const fullWidth = signal<boolean>(false)
export const onClick = signal<(() => void) | undefined>(undefined)
export const keyboardNavigationHints = signal<boolean>(true)
